// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5189":"aefb6c82","7160":"aefb6c82","7924":"aefb6c82","8396":"aefb6c82","9628":"ffe73276"}[chunkId] + ".chunk.css";
};